var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"fab":"","x-small":"","to":_vm.authRoute()}},[_c('v-icon',[_vm._v("mdi-account-circle-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }